// extracted by mini-css-extract-plugin
export var container = "COGSReports-module--container--Ia8zY";
export var content = "COGSReports-module--content--jPAxx";
export var noOrders = "COGSReports-module--noOrders--QyuvS";
export var subHeader = "COGSReports-module--subHeader--Uzo+x";